import request from '@/router/axios'

export function calcPremiumNew(obj = {}) {
	return request({
		url: '/agent/employer/v2/insure/calc_apply',
		method: 'post',
		data: obj,
	})
}

export function getAllProducts(obj = {}) {
	return request({
		url: `/agent/employer/v2/index/main`,
		method: 'post',
		data: obj,
	})
}
